import React from 'react';
import Stats from '../../common/Stats';
import { getSeasonStatsUrl } from '../../data/utils';

function CompetitionRanking(props) {
    const url = getSeasonStatsUrl(props.classifica, props.sport);
    return (        
        <Stats url={url} />
    );
}
 
export default CompetitionRanking;
